import React, { useState } from 'react';
import { saveCustomText } from '../utils/storage';

import mitsumura1 from '../data/texts/mitsumura_grade1.json';
import mitsumura2 from '../data/texts/mitsumura_grade2.json';
import mitsumura3 from '../data/texts/mitsumura_grade3.json';
import tosho1 from '../data/texts/tosho_grade1.json';
import tosho2 from '../data/texts/tosho_grade2.json';
import tosho3 from '../data/texts/tosho_grade3.json';
import kyoiku1 from '../data/texts/kyoiku_grade1.json';
import kyoiku2 from '../data/texts/kyoiku_grade2.json';
import kyoiku3 from '../data/texts/kyoiku_grade3.json';

const ALL_CATALOGS = [mitsumura1, mitsumura2, mitsumura3, tosho1, tosho2, tosho3, kyoiku1, kyoiku2, kyoiku3];

const PUBLISHERS = [
  { value: 'all',       label: '全て' },
  { value: 'mitsumura', label: '光村図書' },
  { value: 'tosho',     label: '東京書籍' },
  { value: 'kyoiku',    label: '教育出版' },
];

const GRADES = [
  { value: 0, label: '全学年' },
  { value: 1, label: '1年' },
  { value: 2, label: '2年' },
  { value: 3, label: '3年' },
];

const GENRE_ICON = {
  '物語': '📖', '説明文': '📄', '詩': '🎵',
  '昔話': '🏮', '短歌': '🎴', '俳句': '🍃',
};

const ALL_WORKS = ALL_CATALOGS.flatMap((cat) =>
  cat.works.map((w) => ({
    ...w,
    publisher: cat.publisher,
    publisher_label: cat.publisher_label,
    grade: cat.grade,
  }))
);

// 出版社ラベルの表示順
const PUB_ORDER = ['光村図書', '東京書籍', '教育出版'];

export default function CatalogSelect({ onSelect, onBack }) {
  const [publisher, setPublisher] = useState('all');
  const [grade, setGrade]         = useState(0);
  const [selectedWork, setSelectedWork] = useState(null);
  const [manualBody, setManualBody]     = useState('');

  const filtered = ALL_WORKS.filter((w) => {
    if (publisher !== 'all' && w.publisher !== publisher) return false;
    if (grade !== 0 && w.grade !== grade) return false;
    return true;
  });

  // 出版社 → 学年 の2段グループ
  const grouped = {};
  filtered.forEach((w) => {
    const pub = w.publisher_label;
    if (!grouped[pub]) grouped[pub] = {};
    const g = w.grade;
    if (!grouped[pub][g]) grouped[pub][g] = [];
    grouped[pub][g].push(w);
  });

  const handleSave = () => {
    const lines = manualBody.split('\n').map((l) => l.trim()).filter((l) => l.length > 0);
    if (lines.length === 0) return;
    const paragraphs = [];
    for (let i = 0; i < lines.length; i += 3) paragraphs.push(lines.slice(i, i + 3));
    const saved = saveCustomText({
      title: selectedWork.title,
      author: selectedWork.author || '',
      genre: selectedWork.genre,
      publisher: selectedWork.publisher,
      grade: selectedWork.grade,
      paragraphs,
    });
    onSelect(saved);
  };

  // 作品選択後 → テキスト入力画面
  if (selectedWork) {
    return (
      <div className="screen manual-input-screen">
        <button className="btn-back" onClick={() => { setSelectedWork(null); setManualBody(''); }}>
          ← もどる
        </button>
        <h3 className="manual-title-head">📖 テキストを　いれよう</h3>
        <p className="manual-sub">
          『{selectedWork.title}』のぶんしょうを　きょうかしょから　うつしてね
        </p>

        <div className="catalog-work-info">
          <span className="text-card-genre">
            {GENRE_ICON[selectedWork.genre] ?? '📝'} {selectedWork.genre}
          </span>
          <span className="text-card-grade">{selectedWork.grade}年</span>
          <span className="catalog-publisher-label">{selectedWork.publisher_label}</span>
        </div>

        <div className="manual-form">
          <label className="manual-label">ぶんしょう</label>
          <p className="manual-hint">
            1ぎょうずつ　かいてね。3ぎょうで　1だんらくになるよ。
          </p>
          <textarea
            className="extracted-text-area"
            placeholder={'れい：\nはるの　かぜが　ふいている。\nゆうびんやさんが　はしった。\nてがみを　とどけた。'}
            value={manualBody}
            onChange={(e) => setManualBody(e.target.value)}
            rows={12}
          />
        </div>

        <button
          className="btn-next"
          style={{ marginTop: 16, width: 'auto', alignSelf: 'center', padding: '4px 32px', flex: 'none' }}
          onClick={handleSave}
          disabled={manualBody.trim().length === 0}
        >
          ✅ ほぞんして　スタート
        </button>
      </div>
    );
  }

  // 作品一覧画面（グループ表示）
  return (
    <div className="screen catalog-screen">
      <button className="btn-back" onClick={onBack}>← もどる</button>
      <h2 className="mode-title">📚 教科書から　えらぼう</h2>
      <p className="catalog-hint-text">
        タイトルを　えらぶと、じぶんで　ぶんしょうを　うつせるよ
      </p>

      {/* フィルター */}
      <div className="filter-row">
        {PUBLISHERS.map((p) => (
          <button
            key={p.value}
            className={`filter-btn ${publisher === p.value ? 'active' : ''}`}
            onClick={() => setPublisher(p.value)}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="filter-row">
        {GRADES.map((g) => (
          <button
            key={g.value}
            className={`filter-btn ${grade === g.value ? 'active' : ''}`}
            onClick={() => setGrade(g.value)}
          >
            {g.label}
          </button>
        ))}
      </div>

      {/* グループ別一覧 */}
      <div className="catalog-grouped-list">
        {filtered.length === 0 && (
          <p className="filter-empty">このフィルターに　あうテキストは　まだないよ</p>
        )}

        {PUB_ORDER.filter((pub) => grouped[pub]).map((pub) => (
          <div key={pub} className="catalog-pub-section">

            {/* 出版社ヘッダー（複数出版社表示時のみ） */}
            {publisher === 'all' && (
              <div className="catalog-pub-header">{pub}</div>
            )}

            {[1, 2, 3].filter((g) => grouped[pub]?.[g]).map((g) => (
              <div key={g} className="catalog-grade-section">

                {/* 学年ヘッダー（複数学年表示時のみ） */}
                {grade === 0 && (
                  <div className="catalog-grade-header">{g}年生</div>
                )}

                <div className="catalog-works-grid">
                  {grouped[pub][g].map((w) => (
                    <button key={w.id} className="catalog-work-card" onClick={() => setSelectedWork(w)}>
                      <span className="catalog-work-icon">{GENRE_ICON[w.genre] ?? '📝'}</span>
                      <span className="catalog-work-title">『{w.title}』</span>
                      {w.author && <span className="catalog-work-author">{w.author}</span>}
                    </button>
                  ))}
                </div>

              </div>
            ))}

          </div>
        ))}
      </div>
    </div>
  );
}
